import React from "react";
import { useSelector } from "react-redux";
import { ROLES } from "../../config/roles";
import RepresentationRequestButtons from "./RepresentationRequestButtons";
import ShareButton from "./ShareButton";
import AddToRadarButton from "../agent-radar/profile/AddToRadarButton";
import ClubAddToRadarButton from "../club-radar/profile/ClubAddToRadarButton";
import ReportDataIssueButton from "../common/ReportDataIssueButton";
import { canUseClubRadar } from "../../utils/clubRoles";

const HeaderActions = ({
  currentRole,
  currentUserProfile,
  representationRequest,
  onRejectRequest,
  onAcceptRequest,
  onShareClick,
  wsPlayerId,
  playerName,
}) => {
  const permissions = useSelector((state) => state.auth.permissions);
  const worksForClub = currentUserProfile?.user_details?.works_for_club;
  const hideForStaffNoClub =
    currentRole === ROLES.Staff && worksForClub === false;

  if (hideForStaffNoClub) return null;

  // "Add to Radar" — the ONLY radar entry point, in the profile header (R10).
  // Agents get the agent radar button; club users (club role + access_radar) get
  // the club radar button; every other role renders nothing (surface unchanged).
  const radarButton =
    currentRole === ROLES.Agent || currentRole === ROLES.AgencyAdmin ? (
      <AddToRadarButton wsPlayerId={wsPlayerId} />
    ) : canUseClubRadar(currentRole, permissions) ? (
      <ClubAddToRadarButton wsPlayerId={wsPlayerId} playerName={playerName} />
    ) : null;

  // "Report data issue" (BUILD-ORDER-data-feedback): always available to any
  // signed-in viewer of the profile — bad data is bad data regardless of role.
  // Self-contained (button + modal); renders null without a wyscout id.
  // flex-wrap on the wrappers below is the declared 375px strategy: the row
  // WRAPS instead of shrinking or overflowing (UI rule 1).
  const reportButton = (
    <ReportDataIssueButton
      entityType="player"
      wyscoutId={wsPlayerId}
      entityName={playerName}
    />
  );

  // Show representation request buttons if available
  if (
    representationRequest &&
    (currentRole === ROLES.Agent || currentRole === ROLES.AgencyAdmin)
  ) {
    const repButtons = (
      <RepresentationRequestButtons
        onReject={onRejectRequest}
        onAccept={onAcceptRequest}
      />
    );
    // The grouping wrapper is unconditional now that the report button always
    // renders alongside (it used to appear only with the radar button).
    return (
      <div className="flex flex-wrap items-center justify-end gap-2">
        {radarButton}
        {repButtons}
        {reportButton}
      </div>
    );
  }

  // Show share button for other cases
  const shareButton = <ShareButton onClick={onShareClick} />;
  return (
    <div className="flex flex-wrap items-center justify-end gap-2">
      {radarButton}
      {shareButton}
      {reportButton}
    </div>
  );
};

export default HeaderActions;
